import { mkButton, WhatsAppGlyph } from "../components/MkButton";
import { ALL_HERO_PRODUCTS, WHATSAPP_URL } from "../site";

/** The last screen of every page: one thing to do, with the shelf resting underneath. */
export function Closing({
	title = "See it on your own catalog.",
	text = "We set up a demo with your products, your branches and your shoppers' languages.",
}: {
	title?: string;
	text?: string;
}) {
	return (
		<section
			aria-labelledby="closing-title"
			className="mk-section overflow-hidden"
		>
			<div className="mk-container text-center">
				<h2
					id="closing-title"
					className="mk-h1 mk-reveal mx-auto max-w-3xl"
				>
					{title}
				</h2>
				<p className="mk-lead mk-reveal mx-auto mt-5 max-w-xl text-(--mk-ink-2)">
					{text}
				</p>
				<div className="mk-reveal mt-9 flex flex-wrap justify-center gap-3">
					<a href="/demo" className={mkButton({ size: "lg" })}>
						Book a demo
					</a>
					<a
						href={WHATSAPP_URL}
						target="_blank"
						rel="noopener"
						className={mkButton({
							variant: "secondary",
							size: "lg",
						})}
					>
						<WhatsAppGlyph />
						Message us
					</a>
				</div>
			</div>
			<ul
				aria-hidden
				className="mk-container mt-16 flex items-end justify-center gap-2 sm:mt-20 sm:gap-5"
			>
				{ALL_HERO_PRODUCTS.slice(0, 9).map((p, i) => (
					<li
						key={p.id}
						className={
							i > 6
								? "hidden w-[9%] shrink-0 sm:block"
								: "w-[13%] shrink-0 sm:w-[9%]"
						}
					>
						<img
							src={p.thumb}
							alt=""
							width={112}
							height={112}
							loading="lazy"
							className="mk-float aspect-square w-full object-contain drop-shadow-[0_16px_14px_oklch(0.2_0.004_270/0.18)]"
							style={{ animationDelay: `${i * -0.8}s` }}
						/>
					</li>
				))}
			</ul>
		</section>
	);
}
